import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    allMenuList: [],
    breadcrumbList: []
  },
  mutations: {
    eidtAllMenuList(state, data) {
      state.allMenuList = data;
      window.sessionStorage.setItem(
        "allMenuList",
        JSON.stringify(state.allMenuList)
      );
    },
    eidtBreadcrumb(state, id) {
      state.breadcrumbList = [];
      let allList = [];
      allList = state.allMenuList.length > 0 ? state.allMenuList : JSON.parse(window.sessionStorage.getItem("allMenuList"));
      allList.forEach(item => {
        if (item.id === id) {
          state.breadcrumbList.push(item);
        }
        item.category.forEach(row => {
          if (row.id === id) {
            state.breadcrumbList.push(item);
            state.breadcrumbList.push(row);
          }
          row.category.forEach(line => {
            if (line.id === id) {
              state.breadcrumbList.push(item);
              state.breadcrumbList.push(row);
              state.breadcrumbList.push(line);
            }
          });
        });
      });
      window.sessionStorage.setItem(
        "breadcrumbList",
        JSON.stringify(state.breadcrumbList)
      );
    }
  }
});
